module.exports = __webpack_public_path__ + "img/profit-tips.a6f8707d.png";